import { InjectionToken, Provider } from '@angular/core';
import { ActionReducerMap } from '@ngrx/store';
import { StateUtils } from '@spartacus/core';
import { TrackingDeliveryApi, TrackingPickup } from '@tracking/const';
import { TRACKING_DELIVERY, TRACKING_PICKUP, TrackingState } from '../tracking-state';

export type TrackingReducers = TrackingState;

export function getReducers(): ActionReducerMap<TrackingReducers> {
  return {
    trackingDelivery: StateUtils.entityLoaderReducer<TrackingDeliveryApi>(TRACKING_DELIVERY),
    trackingPickup: StateUtils.entityLoaderReducer<TrackingPickup>(TRACKING_PICKUP),
  };
}

export const reducerToken: InjectionToken<ActionReducerMap<TrackingReducers>> = new InjectionToken<
  ActionReducerMap<TrackingReducers>
>('TrackingReducers');

export const reducerProvider: Provider = {
  provide: reducerToken,
  useFactory: getReducers,
};
